'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sentry = function (_PureComponent) {
    (0, _inherits3.default)(Sentry, _PureComponent);

    function Sentry() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Sentry);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Sentry.__proto__ || (0, _getPrototypeOf2.default)(Sentry)).call.apply(_ref, [this].concat(args))), _this), _this.initializeSentry = function () {
            /* eslint-disable no-undef */
            if (typeof Raven !== 'undefined') {
                Raven.config('https://fa7392f08ad44440a81d103b44e5b2aa@sentry.io/203557').install();
            }
            /* eslint-enable no-undef */
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Sentry, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.initializeSentry();
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return Sentry;
}(_react.PureComponent);

exports.default = Sentry;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Sentry/Sentry.js
// module id = SWTO
// module chunks = 46